deferjQuery(function () {
    $(document).ready(function() {
        /* Mega Nav Hover */
        var hoverMegaNav;
        $('.doen-header').on('mouseenter', function(e) {
            e.stopPropagation();
            clearTimeout(hoverMegaNav);
            $('.doen-meganav:not([data-trigger="'+$(this).data('handle')+'"])').removeClass('active');
            $('body').removeClass('mega-nav-overlay');
            $('.doen-header').addClass('hover');
            if($('.doen-meganav[data-trigger="'+$(this).data('handle')+'"]').length) {
                $('.doen-meganav[data-trigger="'+$(this).data('handle')+'"]').addClass('active')
                $('body').addClass('mega-nav-overlay');
            }
        });

        $('.doen-header').on('mouseleave', function(e) {
            hoverMegaNav = setTimeout(function() {
                $('.doen-meganav').removeClass('active');
                $('.nav-item__link.open-mega-nav').attr('aria-expanded', "false");
                $('body').removeClass('mega-nav-overlay');
                $('body').removeClass('mega-nav-switching');
     
                if (!$('.doen-header').hasClass('sticky')) {
                    $('.doen-header').removeClass('hover');
                }
            },250);		
        });

        $('.doen-header .nav-item__link[data-handle="New"]').on('mouseenter', function(e) {
            hoverMegaNav = setTimeout(function() {
                $('.doen-meganav').removeClass('active');
                $('.nav-item__link.open-mega-nav').attr('aria-expanded', "false");
                $('body').removeClass('mega-nav-overlay');
                $('body').removeClass('mega-nav-switching');

                if (!$('.doen-header').hasClass('sticky')) {
                    $('.doen-header').removeClass('hover');
                }
            },250);		
        });

        $('.doen-header a.open-mega-nav').on('mouseenter', function(e) {
            e.stopPropagation();
            clearTimeout(hoverMegaNav);
            if ($('.doen-meganav').hasClass('active')) {
                $('body').addClass('mega-nav-switching');
                $('.doen-meganav:not([data-trigger="'+$(this).data('handle')+'"])').removeClass('active');
                $('.nav-item__link.open-mega-nav').attr('aria-expanded', "false");
            }
            $('body').removeClass('mega-nav-overlay');
            $('.doen-header').addClass('hover');
            if($('.doen-meganav[data-trigger="'+$(this).data('handle')+'"]').length) {
                $('.doen-meganav[data-trigger="'+$(this).data('handle')+'"]').addClass('active');
                $(this).attr('aria-expanded', "true");
                $('.doen-meganav[data-trigger="'+$(this).data('handle')+'"]').focus();
                $('body').addClass('mega-nav-overlay');
            }
        });

        $('.doen-header a.open-mega-nav').on('keydown', function(e) {
            if (e.key === 'Space' || e.key === 'Enter') {
                e.preventDefault();
                if ($(this).attr('aria-expanded') == "true") {
                    $(this).trigger('mouseleave');
                } else {
                    $(this).trigger('mouseenter');
                }
            }
        });

        $('.doen-header a.open-mega-nav').on('click', function(e) {
            if($(this).attr('href') == "" || $(this).attr('href') == "#") {
                e.preventDefault();

                if ($(this).attr('aria-expanded') == "true") {
                    $(this).trigger('mouseleave');
                } else {
                    $(this).trigger('mouseenter');
                }
            }
        });


        $(window).on('keydown', function (e) {
            const $focusedOpenMegaNav = $('a.open-mega-nav:focus');

            if (e.keyCode == 32 && $focusedOpenMegaNav.length) {
                e.preventDefault();
                
                if ($focusedOpenMegaNav.attr('aria-expanded') == "true") {
                    $focusedOpenMegaNav.trigger('mouseleave');
                } else {
                    $focusedOpenMegaNav.trigger('mouseenter');
                }
            }
        });

        $('.doen-meganav').on('mouseenter', function(e) {
            e.stopPropagation();
            clearTimeout(hoverMegaNav);
            $('.doen-meganav').not(this).removeClass('active');		
            $('a.open-mega-nav').removeClass('active');
            $(this).addClass('active');
            $('body').addClass('mega-nav-overlay');            
            $('.doen-header').addClass('hover');
            $('a.open-mega-nav[data-handle="'+$(this).data('trigger')+'"]').addClass('active');
        });

        $('.doen-meganav').on('mouseleave', function(e) {
            e.stopPropagation();
            hoverMegaNav = setTimeout(function() {
                $('a.open-mega-nav').removeClass('active');
                $('.doen-meganav').removeClass('active');     
                $('.nav-item__link.open-mega-nav').attr('aria-expanded', "false");             
                $('body').removeClass('mega-nav-overlay');
                $('body').removeClass('mega-nav-switching');

                if (!$('.doen-header').hasClass('sticky')) {
                    $('.doen-header').removeClass('hover');
                }
            },250);
        });
        /* END Mega Nav Hover */

        $('.doen-meganav__sub-nav-toggle').on('click', function(e) {
            e.preventDefault();
            const link = $(this).closest('.doen-meganav__sub-nav').find('.doen-sub-nav__link');
            

            if (!link.hasClass('open')) {
                link.addClass('open');
                link.attr('aria-expanded',"true");
            } else {
                link.removeClass('open');
                link.attr('aria-expanded',"false");
            }
        });

        const subnav = $('.doen-meganav__sub-nav');
        const subnavList = $('.doen-sub-nav__list');

        if (subnav) {
            subnavList.hide();
            const nav = subnav.closest('.nav-item').find('.doen-meganav');
            // const navList = subnav.closest('.nav-item').find('.doen-meganav-left > ul');
            
            nav.css({
                minHeight: nav.outerHeight(true) + subnav.outerHeight(true) + 3
            });

            // navList.css({
            //     paddingBottom: 30 + subnav.outerHeight()
            // })
        }

        if(!$('.doen-header').hasClass('always-hover') || $('body').hasClass('collection')) {
            var lastScrollTop = 0;
            $(window).scroll(function (event) {
                var st = $(this).scrollTop();
                if(st > 0) {
                    $('.doen-header').addClass('sticky').addClass('hover');
                } else {
                    $('.doen-header').removeClass('sticky').removeClass('hover');
                }
                if (st > lastScrollTop && lastScrollTop > 85) {
                $('body').removeClass('scroll-up');
                $('body').addClass('scroll-down');
                } else {
                $('body').addClass('scroll-up');
                $('body').removeClass('scroll-down');
                }
                lastScrollTop = st;
            });
        }

        $('.doen-mobile-menu-open').on('click', function(e) {
            e.preventDefault();
            let doenMobileHeader = document.querySelector('.doen-mobile-header');
            if(doenMobileHeader) {
                doenMobileHeader.classList.add('extended');
                trapFocus(doenMobileHeader);
                let mobileMenuCloseButton = document.querySelector('.doen-mobile-menu-close');
                if( mobileMenuCloseButton ) {
                    mobileMenuCloseButton.focus({ focusVisible: false });
                }
                /*
                let navFirstChild = document.querySelector('.doen-mobile-header.extended .mobile-nav-item .mobile-nav-item__link');
                if( navFirstChild ) {
                    navFirstChild.focus({ focusVisible: true }  );
                }*/
            }
        });

        $('.doen-mobile-menu-close, .mobile-sub-nav a[data-handle="wishlist"]').on('click', function(e) {
            e.preventDefault();
            $('.doen-mobile-header').removeClass('extended');
            $('.doen-mobile-header').removeClass('top-nav-opened');
        });

        $('.open-mobile-sub-nav').on('click', function(e) {
            e.preventDefault();
            //$(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link').addClass('mobile-sub-nav-opened');
            if($(this).hasClass('extended')) {
                $(this).closest('.mobile-nav-item').find('div.mobile-sub-nav').removeClass('active');
                // Not applying :focus-visible styles.
                $('.mobile-nav-item__link[data-handle="'+$(this).data('handle')+'"]').focus({ focusVisible: true });
                $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'hidden');
                // Re-add top-level to tab sequence.
                $('.doen-mobile-nav > .doen-mobile-nav__list .mobile-nav-item__link').each(function(i) { $(this).attr('tabindex', '0') });
                $(this).closest('.mobile-nav-item').find('.open-mobile-sub-nav').attr('aria-expanded', "false");
                $(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link.mobile-sub-nav-opened').removeClass('mobile-sub-nav-opened');
                $('.doen-mobile-header').removeClass('top-nav-opened');

                $(this).removeClass('extended');
            } else {
                $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').addClass('active');
                $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').focus();
                // Prevent kb navigation into parent menu.
                $('.doen-mobile-nav > .doen-mobile-nav__list .mobile-nav-item__link').each(function(i) { $(this).attr('tabindex', '-1') });
                $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'visible');
                $(this).attr('aria-expanded', "true");
                if(!$(this).closest('.doen-mobile-utils').length) {
                    $('.doen-mobile-header').addClass('top-nav-opened');
                }
                $(this).addClass('extended');
            }
            
        });

        $('.open-mobile-sub-sub-nav').on('click', function(e) {
            e.preventDefault();
            if($(this).hasClass('extended')) {
                $(this).closest('.mobile-sub-nav').removeClass('mobile-sub-sub-nav-active');
                $(this).closest('li').removeClass('has-sub-sub-nav-active');
                $(this).closest('li').find('div.mobile-sub-sub-nav').removeClass('active');
                $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'visibile');
                $('.mobile-sub-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'hidden');
                $(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link.mobile-sub-sub-nav-opened').removeClass('mobile-sub-sub-nav-opened');

                $(this).removeClass('extended');
            }   else {
                $(this).closest('.mobile-sub-nav').addClass('mobile-sub-sub-nav-active');
                $(this).closest('li').addClass('has-sub-sub-nav-active');
                $(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link').addClass('mobile-sub-sub-nav-opened');
                $('.mobile-sub-sub-nav[data-trigger="'+$(this).data('handle')+'"]').addClass('active');
                $('.mobile-sub-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'visible');
                $(this).addClass('extended');
            }
        });

        /*
        $('.close-mobile-sub-nav').on('click', function(e) {
            e.preventDefault();
            $(this).closest('div.mobile-sub-nav').removeClass('active');
            // Not applying :focus-visible styles.
            $('.mobile-nav-item__link[data-handle="'+$(this).data('handle')+'"]').focus({ focusVisible: false });
            $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'hidden');
            // Re-add top-level to tab sequence.
            $('.doen-mobile-nav > .doen-mobile-nav__list .mobile-nav-item__link').each(function(i) { $(this).attr('tabindex', '0') });
            $(this).closest('.mobile-nav-item').find('.open-mobile-sub-nav').attr('aria-expanded', "false");
            $(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link.mobile-sub-nav-opened').removeClass('mobile-sub-nav-opened');
            $(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link.mobile-sub-nav-opened').attr('aria-expanded',false);
            $('.doen-mobile-header').removeClass('top-nav-opened');

            if(document.querySelector('.mobile-nav-item__link[data-handle="'+$(this).data('handle')+'"]')) {
                document.querySelector('.mobile-nav-item__link[data-handle="'+$(this).data('handle')+'"]').focus({ focusVisible: false });
            }
        })

        $('.close-mobile-sub-sub-nav').on('click', function(e) {
            e.preventDefault();
            var dataTrigger = $(this).closest('.mobile-sub-nav').data('trigger');
            $(this).closest('.mobile-sub-nav').removeClass('mobile-sub-sub-nav-active');
            $(this).closest('li').removeClass('has-sub-sub-nav-active');
            $(this).closest('div.mobile-sub-sub-nav').removeClass('active');
            $('.mobile-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'visibile');
            $('.mobile-sub-sub-nav[data-trigger="'+$(this).data('handle')+'"]').css('visibility', 'hidden');
            $(this).closest('.doen-mobile-nav').find('.mobile-nav-item__link.mobile-sub-sub-nav-opened').removeClass('mobile-sub-sub-nav-opened');
        })    */    
    });

    $(window).on('load', function() {
        $('.doen-meganav img').removeAttr('loading');
    });

    $('.product .skip-to-content-link').on('click', function(e) {
        $('#ProductInfoWrapper').focus();
    });

    /*
    var modal = document.getElementById("shippingModal");

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target == modal) {
            $('.checkoutMethod').eq(0).find('input[type="radio"]').click();  
            modal.style.display = "none";
            $('.modalCheckout').hide();
        }
    } 
    

    $('body').on('click', '.sameDayShipping', function(){
        //$('#shippingModal').show();
      console.log("INITIALIZE ZAPIET");
        //initializeZapietApp();
        //$('.modalCheckout').hide();
        $("#same-day-shipping").prop("checked", true);
        $('#zapiet-delivery-validator').show();
        $('#zapiet-delivery-validator__topbar').show();
        $('.btn-close[data-bs-dismiss="offcanvas"]').click();
        // var isWidgetRendered = setInterval(function() {
        //     if($('.checkoutMethod').eq(1).length ) {  
                
        //         $('.checkoutMethod').eq(1).find('input[type="radio"]').click(); 
                
        //         $('#shippingModal .searchIcon').html($('#shippingModal .searchIco').html());
                

        //         clearInterval(isWidgetRendered);        
        //     }    
        // }, 250);

        // var isWidgetSearchIconRendered = setInterval(function() {
        //     if($('#shippingModal .searchIcon').length ) {  
                
        //         $('#shippingModal .searchIcon').html($('#shippingModal .searchIco').html());

        //         clearInterval(isWidgetSearchIconRendered);        
        //     }    
        // }, 250);
    })  


    $('body').on('click', '#shippingModal .ks-modal-close', function(){
        $('.checkoutMethod').eq(0).find('input[type="radio"]').click();   
        $('#shippingModal, .modalCheckout').hide();
        $("#same-day-shipping").prop("checked", false)
    })


    $('body').on('click', '#shippingModal .modalCheckout', function(){
        $('.cart__checkout-button').click();  
    })

    window.ZapietEvent?.listen('delivery.datepicker.opened', function(checkout_method) {
        
        $('.modalCheckout').show();
    });

    $('body').on('click', ' .cart-open', function(){
        getLocation();
    });
    */
});

/*
document.addEventListener('product:added', function(event) {
    getLocation();
});

document.addEventListener('egCartDrawerLoaded', function(event) {
    getLocation();
});

// AIzaSyA8tFDVilIPqw6EzTxttMrtfL9rol8__P4

navigator.permissions
  .query({ name: "geolocation" })
  .then((permissionStatus) => {
    if(permissionStatus.state == 'granted') {
        getLocation();
    }
    permissionStatus.onchange = () => {
        if(permissionStatus.state == 'granted') {
            getLocation();
        } else {
            if(sessionStorage.getItem("roadie-eligible")) {
                sessionStorage.removeItem("roadie-eligible");
            }
        }
    };
});

function getLocation()
  {
    if(sessionStorage.getItem("roadie-eligible")) {
        const date = new Date();
        const visitorsDate = convertTZ(date, "America/Los_Angeles");
        if(visitorsDate.getHours() && parseInt(visitorsDate.getHours()) != 0 &&  visitorsDate.getHours() >= 16 ) {
            if($('.sameDayShipping').length) { 
                $('.sameDayShipping').hide();
            }
            if(sessionStorage.getItem("roadie-eligible")) {
                sessionStorage.removeItem("roadie-eligible");
            }
        } else {
            
        }
        if($('.sameDayShipping').length && $('#cart-drawer .product-list-item').length) { 
            $('.sameDayShipping').show();
            sessionStorage.setItem("roadie-eligible", true);
        }
    } else {    
        if (navigator.geolocation)
            {
                navigator.geolocation.getCurrentPosition(showPosition,showError);
            }   
        else{
            console.log("Geolocation is not supported by this browser.");
        }
    }
  }

function showPosition(position)
  {

    let lat=position.coords.latitude;
    let lon=position.coords.longitude;
    const API_key =  'AIzaSyA8BGW8QPfpmdTlsdKpea16xxDflunxhQc'; //'AIzaSyC90fuAKfm9I6DYaHsRm8QIDIHjY2H8dGg';


    let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng="+lat+","+lon+"&key="+API_key+"&sensor=false&language=en&hl=en";
       $.get(url, function(data) {
         //console.log("DATA geocode", data);
       var results = data.results;
           if (data.status === 'OK') 
           {
               //console.log(JSON.stringify(results));
               if (results[0]) 
               {
                   var city = "";
                   var state = "";
                   var country = "";
                   var zipcode = "";
                   
                  var address_components = results[0].address_components;
                   
                   for (var i = 0; i < address_components.length; i++) 
                   {
                      if (address_components[i].types[0] === "administrative_area_level_1" && address_components[i].types[1] === "political") {
                           state = address_components[i].long_name;    
                       }
                       if (address_components[i].types[0] === "locality" && address_components[i].types[1] === "political" ) {                                
                           city = address_components[i].long_name;   
                       }
                       
                       if (address_components[i].types[0] === "postal_code" && zipcode == "") {
                           zipcode = address_components[i].long_name;

                       }
                       
                       if (address_components[i].types[0] === "country") {
                           country = address_components[i].long_name;

                       }
                   }
                 var address = {
                       "city": city,
                       "state": state,
                       "country": country,
                       "zipcode": zipcode,
                 };

                 if(state == 'California') {
                    if($('.sameDayShipping').length) {
                        const date = new Date();
                        const visitorsDate = convertTZ(date, "America/Los_Angeles");
                        if(visitorsDate.getHours() && parseInt(visitorsDate.getHours()) != 0 &&  visitorsDate.getHours() >= 16 ) {
                            if($('.sameDayShipping').length) { 
                                $('.sameDayShipping').hide();
                            }
                            if(sessionStorage.getItem("roadie-eligible")) {
                                sessionStorage.removeItem("roadie-eligible");
                            }
                        } else {
                            if($('.sameDayShipping').length && $('#cart-drawer .product-list-item').length) { 
                                $('.sameDayShipping').show();
                                sessionStorage.setItem("roadie-eligible", true);
                            }
                        }
                    }
                 } else {
                   if($('.sameDayShipping').length) { 
                    $('.sameDayShipping').hide();
                   }
                   if(sessionStorage.getItem("roadie-eligible")) {
                    sessionStorage.removeItem("roadie-eligible");
                    }
                 }
              } 
              else 
              {
                console.log('No results found');
              }
           } 
           else 
           {
            console.log('Geocoder failed due to: ' + data.status);
             if(data.error_message) {
               console.log('Geocoder error_message: ' + data.error_message);
             }
           }
       });
  }

function showError(error)
  {
  switch(error.code) 
    {
    case error.PERMISSION_DENIED:
        console.log("User denied the request for Geolocation.") 
      break;
    case error.POSITION_UNAVAILABLE:
        console.log("Location information is unavailable.")
      break;
    case error.TIMEOUT:
   
      break;
    case error.UNKNOWN_ERROR:
     
      break;
    }
  }



function convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
}
*/

let clickGiftCard = document.querySelector('#upsell-gift');
$("#upsell-gift").click(function(){
    setTimeout(function() { 
        location.reload();
        localStorage.setItem("updatedCard", "Yes");
    }, 400);
  });

let checkStorage = localStorage.updatedCard
let openCartDrawer = document.querySelector('.cart-open');
if (checkStorage === 'Yes') {
    console.log('update cart for same day shipping')
    openCartDrawer.click();
    localStorage.removeItem("updatedCard");
}

document.addEventListener('click', function(e) {
    if(e.target.classList.contains('quick-buy__go-to-product') || e.target.closest('.quick-buy__go-to-product')) {
        e.preventDefault();
        if(openCartDrawer) {
            openCartDrawer.click();
        }
        if(document.querySelector('.quick-buy-overlay')) {
            document.querySelector('.quick-buy-overlay').remove();
            document.body.classList.remove('noScroll');
        }
    }
})

document.addEventListener('keydown', async (e) => {
    if (e.code === 'Enter' && e.target.classList.contains('card__size') && !e.target.classList.contains('is-unavailable')) {
        var itemToAdd = {
            id: Number(e.target.dataset.variantId),
            quantity: 1
        }
        if(e.target.dataset.finalSale) {
            itemToAdd.properties = {
                'Final Sale': "This item is Final Sale"
            }
        }
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [itemToAdd]
            })
        })

        const data = await response.json();

        if(data) {
            openCartDrawer.click();
            loadEgCartDrawer();            
        }
    }
});

document.addEventListener('click', async (e) => {
    if(e.target.classList.contains('card__size') && !e.target.classList.contains('is-unavailable')) {
        var itemToAdd = {
            id: Number(e.target.dataset.variantId),
            quantity: 1
        }
        if(e.target.dataset.finalSale) {
            itemToAdd.properties = {
                'Final Sale': "This item is Final Sale"
            }
        }
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [itemToAdd]
            })
        })

        const data = await response.json();

        if(data) {
            openCartDrawer.click();
            loadEgCartDrawer();

            // Dispatch saved cart item event for customer accounts
            const addedItem = data.items[0];
            const gwCustomerAccounts = document.querySelector('gw-customer-accounts');
            if (gwCustomerAccounts) {
                const variantId = addedItem.variant_id;
                const productId = addedItem.product_id;
                if (!variantId && !productId) return;
                
                const event = new CustomEvent('gw:saved-items-from-cart', {
                    detail: { 
                        productId: productId,
                        variantId: variantId,
                        target: e.target,
                        extra: addedItem
                    }
                });

                gwCustomerAccounts.dispatchEvent(event);
            }
        }
    }

    if(e.target.classList.contains('sticky_size_guide')) {
        e.preventDefault();
        $('.ks-chart-modal-link')?.click();
    }
})
// Add support for focus outlines on tab only
document.addEventListener('keydown', (event) => {
    // Check if the Tab key was pressed
    if (event.code === 'Tab') {
      // Add focus class to the body
      document.body.classList.add('show-focus-outlines');
    }
    
      if (event.target.classList.contains('aa-product')) {
          if (event.code === 'Enter') {
              event.target.closest('.aa-suggestion').click();
          }
      }
  
      if (event.target.classList.contains('aa-title') && (event.target.closest('.aa-page') || event.target.closest('.aa-article'))) {
          if (event.code === 'Enter') {
              event.target.closest('.aa-suggestion').click();
          }
      }
  });


document.addEventListener('DOMContentLoaded', function () {

    let input = $('#create_customer input');

    input.on("focus", function() {
        $(this).parent().find('label').addClass('on-focus');
    });

    input.on("blur", function() {
        if($(this).val().length === 0) {
            $(this).parent().find('label').removeClass('on-focus');
        }
    });

    $(document).keyup(function(e) {
        if (e.key === "Escape") { 
            let elements = document.getElementsByClassName("doen-meganav active");
            for(let el of elements) {
                el.classList.remove("active");
            } 
        }
    });

    var checkPopupButton = setInterval(function() {
        if ($('.recommendation-modal__button').length) {
            console.log('Appeared')
            $('.recommendation-modal__button').attr("tabindex","-1")
            $('.recommendation-modal__button').attr("id","modal-button-continue")
            $('#modal-button-continue').focus()
           clearInterval(checkPopupButton);
        }
     }, 2000)



    let klavyioInput = $('#email_signup_window_b input');

    klavyioInput.on("focus", function() {
        $(this).parent().find('label').addClass('on-focus');
    });

    klavyioInput.on("blur", function() {
        if($(this).val().length === 0) {
            $(this).parent().find('label').removeClass('on-focus');
        }
    });


    $('.algolia-search-close').click(function(){
        $('.doen-search-button a').focus();
    })

    $('body').on('keydown', e => {
        if($('.kiwi-sizing-modal[role=dialog]').hasClass('show')) {
            let shiftPressed = e.shiftKey;
            if(e.keyCode === 9 && shiftPressed) {
                e.preventDefault();
                $('.kiwi-sizing-modal .ks-modal-close').focus();
                return false;
            }
        }
    });
});


//focus gift when modal is open 
// document.addEventListener('egCartDrawerLoaded', function(event) {
//     if(document.getElementById("cart-upsell")) {
//         document.getElementById("cart-upsell").focus();
//     }
// });

document.addEventListener('keydown', function(e) {
    if(e.key == "Tab") {
        if(!e.shiftKey) {
            if(document.activeElement.dataset.handle == "currency-menu") {
                window.tabbedOnCurrencyMenu = true
            }
            if (window.tabbedOnLastSubNavItem) {
                e.target.closest('.mobile-nav-item').querySelector('.close-nav-layer').focus();
                window.tabbedOnLastSubNavItem = false;
            }
        }   
        if(e.shiftKey) {
            if(document.activeElement.classList.contains("doen-mobile-menu-close")) {
                window.shiftTabbedOnCloseMobileMenu = true;
            }   
        }
    }
});

document.addEventListener('keyup', function(e) {
    if(e.key == "Enter" || e.code == "Space") {
        if(e.target.classList.contains('sizing-chart-modal-link') || e.target.closest('.sizing-chart-modal-link')) {
            if(document.querySelector('.product__conversion-guide .sizing-chart-modal-link.sizing-chart-modal-link')) {
                document.querySelector('.product__conversion-guide .sizing-chart-modal-link.sizing-chart-modal-link').click();
            }
        }
        if(e.target.classList.contains('.sheerness-container') || e.target.closest('.sheerness-container')) {
            document.querySelector('.sheerness-container').click();
        }
    }
    if(e.key == "Tab") {
        if(!e.shiftKey) {
            if(window.tabbedOnCurrencyMenu) {
                document.querySelector('.doen-mobile-menu-close').focus();
                window.tabbedOnCurrencyMenu = false
            }
            if ( e.target.parentNode.classList.contains("last-item") ) {
                window.tabbedOnLastSubNavItem = true;
            }
        }
        if(e.shiftKey) {
            if (window.shiftTabbedOnCloseMobileMenu) {
                if (!document.querySelectorAll('.doen-mobile-nav *[aria-expanded="true"]').length) {
                    document.querySelector('.mobile-nav-item a[data-handle="currency-menu"]').focus()
                } else {
                    if ( document.querySelector('.has-sub-sub-nav-active') ) {
                        document.querySelector('.has-sub-sub-nav-active .last-item a').focus();
                        window.tabbedOnLastSubNavItem = true;
                    } else {
                        document.querySelector('.nav-container.active > ul > .last-item a').focus();
                        window.tabbedOnLastSubNavItem = true;
                    }
                }
                window.shiftTabbedOnCloseMobileMenu = false;                
            }
        }
    }
});


function deferKiwiSizing(method) {
    if (typeof window.ks == "object") {
        method();
    } else {
        setTimeout(function() {             
            deferKiwiSizing(method)
        }, 50);
    }
}

deferKiwiSizing(function() {
    ks.on("sizing_loaded", function(data) {
        console.log("sizing_loaded", data);
        $('.size-guide-container')?.append('<button class="sticky_size_guide">Size Guide</button>');
    });
    ks.on("modal_open", function(data) {
        console.log("modal_open", data);
        $('.kiwi-sizing-modal .modal-title-header').attr('id', "modal-header" )
        $('.kiwi-sizing-modal').attr("role", "dialog");
        $('.kiwi-sizing-modal').attr("aria-modal", "true");
        $('.kiwi-sizing-modal').attr("aria-labelledby", "modal-header");
        $('.kiwi-sizing-modal').addClass('show');
        $(".ks-modal-close").replaceWith(function() {
            return $("<button>", { 
                html: this.innerHTML,
                class: this.className,
                'aria-label': $(this).attr('aria-label'),
                'data-modal-close': true
            });
        });
        $(".modal-title-header").replaceWith(function() {
            return $("<h1>", { 
                html: this.innerHTML,
                class: this.className
            });
        });
        $(".ks-table-header").replaceWith(function() {
            return $("<h2>", { 
                html: this.innerHTML,
                class: this.className
            });
        });
    
        $('.kiwi-sizing-modal .ks-modal-close').focus();
    });

    const htmlObserver = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
        if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
        ) {
        const htmlEl = mutation.target;
        if (
            !htmlEl.classList.contains('kiwi-sizing-modal-visible') &&
            mutation.oldValue &&
            mutation.oldValue.includes('kiwi-sizing-modal-visible')
        ) {
            if (window.scrollYOnMobileQuickBuy) {
            window.scrollTo(0, window.scrollYOnMobileQuickBuy);
            window.scrollYOnMobileQuickBuy = null;
            }
        }
        }
    }
    });

    htmlObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
    });
    
});


document.addEventListener('click', (e) => {
    // Remove focus class from the body
    document.body.classList.remove('show-focus-outlines');

    if(e.target.classList.contains('polaris-preferences-widget__close_button') || e.target.closest('.polaris-preferences-widget__close_button')) {
        var polarisConsentWidgets = document.getElementById('polaris-consent-widgets');
        if(polarisConsentWidgets) {
            removeTrapFocus(polarisConsentWidgets);
        }
        
        document.getElementById('skip-to-content').focus();
    }
});

const consentObserverPolaris = new MutationObserver(function(mutationsList, observer) {
  for (const mutation of mutationsList) {
    mutation.addedNodes.forEach(function(node) {
      if (
        node.nodeType === 1 &&
        node.id === 'polaris-consent-widgets'
      ) {
        node.setAttribute('role', 'dialog');
        node.setAttribute('aria-modal', 'true');
        node.setAttribute('aria-label', 'Set Cookie Preferences');
        node.style.zIndex = '9999999999';
        observer.disconnect();
        trapFocus(node);
      }
    });
  }
});

// Initial check in case it's already present
const consentWidgetPolaris = document.getElementById('polaris-consent-widgets');
if (consentWidgetPolaris) {
    consentWidgetPolaris.setAttribute('role', 'dialog');
    consentWidgetPolaris.setAttribute('aria-modal', 'true');
    consentWidgetPolaris.setAttribute('aria-label', 'Set Cookie Preferences');
    consentWidgetPolaris.style.zIndex = '9999999999';
} else {
  consentObserverPolaris.observe(document, { childList: true, subtree: true });
}

const ksChartModalLinkObserver = new MutationObserver(function(mutationsList, observer) {
  for (const mutation of mutationsList) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) {
        // If the added node itself is .ks-chart-modal-link
        if (node.classList.contains('ks-chart-modal-link')) {
          node.setAttribute('role', 'button');
          node.setAttribute('tabindex', '0');
        }
        // If descendants contain .ks-chart-modal-link
        node.querySelectorAll?.('.ks-chart-modal-link').forEach(function(el) {
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
        });
      }
    });
  }
});

// Initial check in case elements already exist
document.querySelectorAll('.ks-chart-modal-link').forEach(function(el) {
  el.setAttribute('role', 'button');
  el.setAttribute('tabindex', '0');
});

// Start observing for future additions
ksChartModalLinkObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('focusin', function(e) {
  if (e.target.id === 'predictive_search_field') {
    const describedbyId = e.target.getAttribute('aria-describedby');
    if (describedbyId) {
      const describedElement = document.getElementById(describedbyId);
      if (describedElement) {
        describedElement.setAttribute('aria-hidden', 'false');
      }
    }
  }  
});

document.addEventListener('focusout', function(e) {
  if (e.target.id === 'predictive_search_field') {
    const describedbyId = e.target.getAttribute('aria-describedby');
    if (describedbyId) {
      const describedElement = document.getElementById(describedbyId);
      if (describedElement) {
        describedElement.setAttribute('aria-hidden', 'true');
      }
    }
  }
});